import { AppRouteRecordRaw } from '../types';
import { PARTNER_TYPES } from '@/constants/partner-types';
import { Roles } from '@/constants/roles';

const Body = () => import('@/components/body.vue');
const PartnerExchangeFilesQ8 = () =>
  import('@/pages/ryd-financial/partner-file-hub/q8/PartnerExchangeFilesQ8.vue');
const TamoilReconciliationProcess = () =>
  import('@/pages/ryd-financial/partner-file-hub/tamoil/TamoilReconciliationProcess.vue');
const EgReconciliation = () => import('@/pages/ryd-financial/eg/EgReconciliation.vue');
const ListPriceReports = () =>
  import('@/pages/ryd-financial/list-price-reports/ListPriceReports.vue');
const InvoiceFailedCreation = () =>
  import('@/pages/ryd-financial/invoicing/failed-requests/InvoiceFailedCreation.vue');
const DataConsistencyCheck = () =>
  import('@/pages/ryd-financial/invoicing/data-consistency-check/DataConsistencyCheck.vue');
const InvoiceCancellation = () =>
  import('@/pages/ryd-financial/invoicing/invoice-cancellation/InvoiceCancellation.vue');
const InvoiceModification = () =>
  import('@/pages/ryd-financial/invoicing/invoice-modification/InvoiceModification.vue');
const EinvoiceValidation = () =>
  import('@/pages/ryd-financial/invoicing/e-invoice-validation/EinvoiceValidation.vue');
const EinvoiceRepair = () =>
  import('@/pages/ryd-financial/invoicing/e-invoice-repair/EinvoiceRepair.vue');
const B2cCountryProductReport = () =>
  import('@/pages/ryd-financial/reporting/b2c-invoices/B2cCountryProductReport.vue');
const OdooOrderMonitorPage = () =>
  import('@/pages/ryd-financial/invoicing/odoo-order-monitor/OdooDelayMonitorPage.vue');
const RydFinancialOverview = () =>
  import('@/pages/ryd-financial/overview/RydFinancialOverview.vue');
const FiscalMonitoringPoland = () =>
  import('@/pages/ryd-financial/fiscal-monitoring/poland/FiscalMonitoringPolandPage.vue');
const FiscalMonitoringMoloni = () =>
  import('@/pages/ryd-financial/fiscal-monitoring/moloni/FiscalMonitoringMoloniPage.vue');
const PolandOutboundDetail = () =>
  import('@/pages/ryd-financial/fiscal-monitoring/poland/outbound-detail/PolandOutboundDetailPage.vue');
const PolandInboundDetail = () =>
  import('@/pages/ryd-financial/fiscal-monitoring/poland/inbound-detail/PolandInboundDetailPage.vue');
const PolandOutboundResend = () =>
  import('@/pages/ryd-financial/fiscal-monitoring/poland/resend/PolandOutboundResendPage.vue');
const PolandOrderResend = () =>
  import('@/pages/ryd-financial/fiscal-monitoring/poland/resend/PolandOrderResendPage.vue');
const MoloniCallDetail = () =>
  import('@/pages/ryd-financial/fiscal-monitoring/moloni/call-detail/MoloniCallDetailPage.vue');
const MoloniOperationDetail = () =>
  import('@/pages/ryd-financial/fiscal-monitoring/moloni/operation-detail/MoloniOperationDetailPage.vue');

export const accountingRoutes: AppRouteRecordRaw[] = [
  {
    path: '/accounting',
    component: Body,
    meta: {
      breadcrumb: 'ryd Financial',
    },
    children: [
      {
        path: 'overview',
        name: 'rydFinancialOverview',
        component: RydFinancialOverview,
        meta: {
          title: 'ryd Financial Overview | ryd Portal',
          breadcrumb: 'Overview',
        },
      },
      {
        path: 'partner-file-hub/q8',
        name: 'partnerExchangeFiles',
        component: PartnerExchangeFilesQ8,
        meta: {
          title: 'Accounting - Partner File Hub | ryd Portal',
          breadcrumb: 'Q8 Reconciliation Process',
        },
      },
      {
        path: 'partner-file-hub/tamoil',
        name: 'tamoilReconciliationProcess',
        component: TamoilReconciliationProcess,
        meta: {
          title: 'Accounting - Tamoil Reconciliation Process | ryd Portal',
          breadcrumb: 'Tamoil Reconciliation Process',
        },
      },
      {
        path: 'eg',
        name: 'egReconciliation',
        component: EgReconciliation,
        meta: {
          title: 'Accounting - EG Reconciliation | ryd Portal',
          breadcrumb: 'EG Reconciliation',
        },
      },
      {
        path: 'list-price-reports',
        name: 'listPriceReports',
        component: ListPriceReports,
        meta: {
          title: 'Accounting - List Price Reports | ryd Portal',
          breadcrumb: 'List Price Reports',
        },
      },
      {
        path: 'invoicing/failed-requests',
        name: 'InvoiceFailedCreation',
        component: InvoiceFailedCreation,
        meta: {
          title: 'Failed Invoice Creation',
          breadcrumb: 'Failed Invoice Generation',
        },
      },
      {
        path: 'invoicing/data-consistency-check',
        name: 'DataConsistencyCheck',
        component: DataConsistencyCheck,
        meta: {
          title: 'Data Consistency Check',
          breadcrumb: 'Data Consistency Check',
        },
      },
      {
        path: 'invoicing/odoo-order-monitor',
        name: 'accountingOdooOrderMonitor',
        component: OdooOrderMonitorPage,
        meta: {
          title: 'Odoo Order Monitor | ryd Portal',
          breadcrumb: 'Odoo Order Monitor',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
      {
        path: 'invoicing/invoice-mirror',
        redirect: '/fleet-operations/partner-billing/fleet-invoice-data-hub',
      },
      {
        path: 'invoicing/odoo-delay-monitor',
        redirect: '/accounting/invoicing/odoo-order-monitor',
      },
      {
        path: 'invoicing/invoice-cancellation',
        name: 'InvoiceCancellation',
        component: InvoiceCancellation,
        meta: {
          title: 'Invoice Cancellation | ryd Portal',
          breadcrumb: 'Invoice Cancellation',
        },
      },
      {
        path: 'invoicing/invoice-modification',
        name: 'InvoiceModification',
        component: InvoiceModification,
        meta: {
          title: 'Invoice Modification | ryd Portal',
          breadcrumb: 'Invoice Modification',
        },
      },
      {
        path: 'invoicing/e-invoice-validation',
        name: 'accountingEinvoiceValidation',
        component: EinvoiceValidation,
        meta: {
          title: 'E-Invoice Validation | ryd Portal',
          breadcrumb: 'E-Invoice Validation',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
      {
        path: 'invoicing/e-invoice-repair',
        name: 'accountingEinvoiceRepair',
        component: EinvoiceRepair,
        meta: {
          title: 'E-Invoice Repair | ryd Portal',
          breadcrumb: 'E-Invoice Repair',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
      {
        path: 'reporting/b2c-invoices',
        name: 'accountingReportingB2cInvoices',
        component: B2cCountryProductReport,
        meta: {
          title: 'B2C Invoices | ryd Portal',
          breadcrumb: 'B2C Invoices',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
          requiredRoles: [Roles.accountingAdmin],
        },
      },
      {
        path: 'fiscal-monitoring/poland',
        name: 'fiscalMonitoringPoland',
        component: FiscalMonitoringPoland,
        meta: {
          title: 'Poland Fiscal Monitoring | ryd Portal',
          breadcrumb: 'Poland (Exorigo-Upos)',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
      {
        path: 'fiscal-monitoring/moloni',
        name: 'fiscalMonitoringMoloni',
        component: FiscalMonitoringMoloni,
        meta: {
          title: 'Moloni Fiscal Monitoring | ryd Portal',
          breadcrumb: 'Moloni (Portugal)',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
      // Every fiscal record has its own URL, so an investigation can be handed to someone else
      // as a link instead of a set of filters to reproduce.
      {
        path: 'fiscal-monitoring/poland/outbound/:odooId',
        name: 'fiscalMonitoringPolandOutboundDetail',
        component: PolandOutboundDetail,
        meta: {
          title: 'Outbound Fiscal Request | ryd Portal',
          breadcrumb: 'Outbound Request',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
      {
        path: 'fiscal-monitoring/poland/inbound/:eventId',
        name: 'fiscalMonitoringPolandInboundDetail',
        component: PolandInboundDetail,
        meta: {
          title: 'Inbound Fiscal Callback | ryd Portal',
          breadcrumb: 'Inbound Callback',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
      {
        path: 'fiscal-monitoring/poland/outbound/:odooId/resend',
        name: 'fiscalMonitoringPolandOutboundResend',
        component: PolandOutboundResend,
        meta: {
          title: 'Resend SmartOrder Sale | ryd Portal',
          breadcrumb: 'Resend Payload',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
      // Entry point keyed on the order UUID instead of an Odoo row id — deeplinkable via
      // `?orderUuid=…`, resolves to the latest SmartOrder request and links into the editor.
      {
        path: 'fiscal-monitoring/poland/resend',
        name: 'fiscalMonitoringPolandOrderResend',
        component: PolandOrderResend,
        meta: {
          title: 'Resend SmartOrder By Order UUID | ryd Portal',
          breadcrumb: 'Resend By Order UUID',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
      {
        path: 'fiscal-monitoring/moloni/calls/:odooId',
        name: 'fiscalMonitoringMoloniCallDetail',
        component: MoloniCallDetail,
        meta: {
          title: 'Moloni API Call | ryd Portal',
          breadcrumb: 'API Call',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
      {
        path: 'fiscal-monitoring/moloni/operations/:odooId',
        name: 'fiscalMonitoringMoloniOperationDetail',
        component: MoloniOperationDetail,
        meta: {
          title: 'Moloni Invoice Operation | ryd Portal',
          breadcrumb: 'Invoice Operation',
          requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
          requiredUserGroup: ['ryd'],
        },
      },
    ],
  },
];
